<div fxLayout="column" fxLayoutGap="16px" class="container">
  @if (!isLoadingLegs) {
  <h1
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutGap="8px"
    fxLayoutAlign="start center"
  >
    <span>
      {{ activeLegId }} |
      {{ calculateTimeDifference(legs[activeLegId - 1]).timeDiff }} |
      <span [ngClass]="compareTimeToCheckpoint(legs[activeLegId - 1]).cssClass">
        {{ compareTimeToCheckpoint(legs[activeLegId - 1]).formattedDiff }}
      </span>
    </span>
  </h1>
  <h2
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutGap="8px"
    fxLayoutAlign="start center"
  >
    R | {{ getRemainingTravelDistance() }}m | {{ getRemainingTravelTime() }} |
    {{ getRemainingPoints() }}p
  </h2>
  <h2
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutGap="8px"
    fxLayoutAlign="start center"
  >
    T | {{ getTotalTravelDistance() }}m | {{ getTotalTravelTime() }} |
    {{ getTotalIncludedPoints() }}p
  </h2>
  }

  <h3>Included: {{ sortedIncludedBonuses.length }}</h3>
  @if (isLoadingBonuses) {
  <div>Loading bonuses...</div>
  } @else {
  <mat-accordion multi="true">
    @if (sortedIncludedBonuses.length) { @for (bonus of sortedIncludedBonuses;
    track bonus.BonusCode) {
    <mat-expansion-panel>
      <mat-expansion-panel-header
        [ngClass]="{ 'visited-green': bonus.Visited }"
      >
        <mat-panel-title>
          {{ bonus.BonusCode }} | {{ bonus.BonusName }} | {{ bonus.Points }}p
          |&nbsp;
          <span
            [ngStyle]="
              bonus.LayoverMinutes !== 10 && bonus.LayoverMinutes !== 0
                ? { color: 'red' }
                : {}
            "
          >
            {{ bonus.LayoverMinutes }}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="column" fxFlexWrap="wrap">
        <div fxLayout="row" fxFlexWrap="wrap">
          <span class="route-details">
            {{ bonus.Description }} | Hours: {{ bonus.AvailableHours }}
          </span>
        </div>
        <div
          fxLayout="row"
          fxFlexWrap="wrap"
          fxLayoutGap="20px"
          class="margin-top-30"
        >
          <a
            mat-flat-button
            fxFlex="1 1 50%"
            [href]="getGoogleMapsUrl(bonus)"
            target="_blank"
            rel="noopener noreferrer"
            >Maps</a
          >
          <a
            mat-flat-button
            fxFlex="1 1 50%"
            [href]="getWazeUrl(bonus)"
            target="_blank"
            rel="noopener noreferrer"
            >Waze</a
          >
          <mat-slide-toggle
            fxFlex
            [(ngModel)]="bonus.Visited"
            (ngModelChange)="updateBonusVisited(bonus, $event)"
            >Visited</mat-slide-toggle
          >
        </div>
        <div fxLayout="row" fxFlexWrap="wrap" class="margin-top-30">
          @if (getRouteForBonus(bonus)) {
          <span class="route-details">
            ETA:
            {{
              calculateEta(
                calculateTimeDifference(legs[activeLegId - 1]).referenceTime,
                getRouteForBonus(bonus).runningTravelTimeMinutes
              )
            }}
            <br />
            From previous:
            {{ formatTime(getRouteForBonus(bonus).travelTimeMinutes) }},
            {{ getRouteForBonus(bonus).distanceMiles }}m
            <br />
            Running total:
            {{ formatTime(getRouteForBonus(bonus).runningTravelTimeMinutes) }},
            {{ getRouteForBonus(bonus).runningDistanceMiles }}m
          </span>
          }
        </div>
        <div
          fxLayout="row"
          fxFlexWrap="wrap"
          fxLayoutGap="20px"
          class="margin-top-30"
        >
          <mat-form-field appearance="outline" fxFlex="1 1 40%">
            <mat-label>Layover</mat-label>
            <input
              matInput
              type="number"
              min="0"
              [(ngModel)]="bonus.LayoverMinutes"
              (ngModelChange)="updateBonusLayover(bonus, $event)"
            />
          </mat-form-field>
          <button
            mat-icon-button
            fxFlex="1 1 15%"
            [disabled]="isUpButtonDisabled(bonus)"
            (click)="moveBonusUp(bonus)"
          >
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button
            mat-icon-button
            fxFlex="1 1 15%"
            [disabled]="isDownButtonDisabled(bonus)"
            (click)="moveBonusDown(bonus)"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <mat-slide-toggle
            fxFlex="1 1 30%"
            [(ngModel)]="bonus.Include"
            (ngModelChange)="updateBonusInclude(bonus, $event)"
            >Include</mat-slide-toggle
          >
        </div>
      </div>
    </mat-expansion-panel>
    } } @else {
    <p>No included bonuses available.</p>
    }
  </mat-accordion>
  }

  <h3>Available: {{ sortedNotIncludedBonuses.length }}</h3>
  @if (isLoadingBonuses) {
  <div>Loading bonuses...</div>
  } @else {
  <mat-accordion>
    @if (sortedNotIncludedBonuses.length) { @for (bonus of
    sortedNotIncludedBonuses; track bonus.BonusCode) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ bonus.BonusCode }} | {{ bonus.BonusName }} | {{ bonus.Points }}p
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        fxLayout="row"
        fxLayout.gt-sm="row"
        fxLayoutGap="20px"
        fxFlexWrap="wrap"
      >
        <a
          mat-flat-button
          fxFlex="1 1 50%"
          [href]="getGoogleMapsUrl(bonus)"
          target="_blank"
          rel="noopener noreferrer"
          >Maps</a
        >
        <a
          mat-flat-button
          fxFlex="1 1 50%"
          [href]="getWazeUrl(bonus)"
          target="_blank"
          rel="noopener noreferrer"
          >Waze</a
        >
        <mat-slide-toggle
          fxFlex
          [(ngModel)]="bonus.Include"
          (ngModelChange)="updateBonusInclude(bonus, $event)"
          >Include</mat-slide-toggle
        >
      </div>
    </mat-expansion-panel>
    } } @else {
    <p>No not included bonuses available.</p>
    }
  </mat-accordion>
  } @if (false) {
  <h3>Settings</h3>
  <div fxLayout="column" fxLayoutGap="8px">Active Leg</div>
  @if (!isLoadingLegs) {
  <mat-radio-group
    [(ngModel)]="activeLegId"
    fxLayout="row wrap"
    fxLayoutGap="8px"
  >
    @for (leg of legs; track leg.Leg) {
    <mat-radio-button [value]="leg.Leg" (change)="updateActiveLegId(leg.Leg)"
      >Leg {{ leg.Leg }}</mat-radio-button
    >
    }
  </mat-radio-group>
  } }

  <div class="margin-top-30">
    <button mat-flat-button (click)="clearChecklistToggles()">
      Clear Checklist
    </button>
    <div>
      <h4>Bonus</h4>
      <ul>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Check Rally Book
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Picture: Angle, Distance
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Submit Bonus (Audio, Lat, Lon)
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Pack Flag!
        </li>
      </ul>
    </div>
    <div>
      <h4>Meal</h4>
      <ul>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Start Clock
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Picture: Flag, Food, Menu
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          End Clock
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Submit Bonus (Time, Lat, Lon)
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Pack Flag!
        </li>
      </ul>
    </div>
    <div>
      <h4>Rest</h4>
      <ul>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Start Clock
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Aux Power Off
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Bubbler Off
        </li>
        <hr />
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Bubbler On
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Aux Power On
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Picture: Rider's Choice
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          End Clock
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Submit Bonus (Time, Lat, Lon)
        </li>
      </ul>
    </div>
    <div>
      <h4>Gas</h4>
      <ul>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Reset Odometer
        </li>
      </ul>
    </div>
    <div>
      <h4>All</h4>
      <ul>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Trash
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Snack
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Yeti
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Gear Change
        </li>
        <li>
          <mat-slide-toggle #checklistToggle></mat-slide-toggle>
          Helmet Charger
        </li>
      </ul>
    </div>
  </div>
</div>
